import { createStore, combineReducers, applyMiddleware } from "redux";
import { thunk } from "redux-thunk";
import { composeWithDevTools } from "@redux-devtools/extension"; // "redux-devtools-extension";
import {
  postCreateReviewReducer,
  postDetailsReducer,
  postListReducer,
  postUpsertReducer,
  postDeleteReducer,
  postEditReducer,
  postByBusinessListReducer,
  postLikeReducer,
  postShareReducer,
  postViewReducer,
  postAnalyticsReducer,
} from "./Reducers/PostReducers";
import {
  profileCreateReducer,
  profileEditReducer,
  profileUpdateReducer,
  profileListReducer,
} from "./Reducers/ProfileReducers";

import {
  userDetailsReducer,
  userLoginReducer,
  userRegisterReducer,
  userUpdateProfileReducer,
  userListReducer,
  userConfirmReducer,
} from "./Reducers/userReducers";

import {
  recordCreateReducer,
  recordDeleteReducer,
  recordEditReducer,
  recordListReducer,
  recordUpdateReducer,
} from "./Reducers/RecordReducers";
import { docUploadReducer } from "./Reducers/UploadReducers";

import {
  categoryCreateReducer,
  categoryDeleteReducer,
  categoryEditReducer,
  categoryListReducer,
  categoryUpdateReducer,
} from "./Reducers/CategoryReducers";

import {
  mallCreateReducer,
  mallDeleteReducer,
  mallEditReducer,
  mallListReducer,
  mallUpdateReducer,
} from "./Reducers/MallReducers";

import { currentLocationReducer } from "./Reducers/CurrentLocationReducers";

import {
  payfastExecuteReducer,
  paymentSubscriptionActionReducer,
  payfastSignatureReducer,
} from "./Reducers/PaymentReducers";

import {
  subscriptionActivateReducer,
  subscriptionPayReducer,
  subscriptionDetailsReducer,
} from "./Reducers/SubscriptionReducers";

import {
  oauthDeleteReducer,
  oauthEditReducer,
  oauthUpdateReducer,
  oauthFacebookPagesGetReducer,
  oauthFacebookPageSelectReducer,
  oauthInstagramAccountsGetReducer,
  oauthInstagramAccountSelectReducer,
} from "./Reducers/OAuthReducers";

import { dashboardGetReducer } from "./Reducers/DashboardReducers";

import { supportSendReducer } from "./Reducers/SupportReducers";

import {
  rfqCreateReducer,
  rfqListReducer,
  rfqGetReducer,
  quoteSubmitReducer,
  rfqQuoteListReducer,
  quoteAcceptReducer,
  leadListReducer,
} from "./Reducers/QuoteReducers";

const reducer = combineReducers({
  postList: postListReducer,
  postDetails: postDetailsReducer,
  postReviewCreate: postCreateReviewReducer,
  postUpsert: postUpsertReducer,
  postDelete: postDeleteReducer,
  postEdit: postEditReducer,
  postByBusinessList: postByBusinessListReducer,
  postLike: postLikeReducer,
  postShare: postShareReducer,
  postView: postViewReducer,
  postAnalytics: postAnalyticsReducer,

  profileCreate: profileCreateReducer,
  profileEdit: profileEditReducer,
  profileUpdate: profileUpdateReducer,
  profileList: profileListReducer,

  dashboardGet: dashboardGetReducer,

  oauthDelete: oauthDeleteReducer,
  oauthEdit: oauthEditReducer,
  oauthUpdate: oauthUpdateReducer,
  oauthGetFacebookPages: oauthFacebookPagesGetReducer,
  oauthFacebookPageSelect: oauthFacebookPageSelectReducer,
  oauthGetInstagramAccounts: oauthInstagramAccountsGetReducer,
  oauthInstagramAccountSelect: oauthInstagramAccountSelectReducer,

  subscriptionActivate: subscriptionActivateReducer,
  subscriptionPay: subscriptionPayReducer,
  subscriptionDetails: subscriptionDetailsReducer,

  payfastExecute: payfastExecuteReducer,
  paymentSubscriptionAction: paymentSubscriptionActionReducer,
  payfastSignature: payfastSignatureReducer,

  currentLocation: currentLocationReducer,

  userLogin: userLoginReducer,
  userRegister: userRegisterReducer,
  userConfirm: userConfirmReducer,
  userDetails: userDetailsReducer,
  userUpdateProfile: userUpdateProfileReducer,
  userList: userListReducer,

  docUpload: docUploadReducer,

  categoryList: categoryListReducer,
  categoryCreate: categoryCreateReducer,
  categoryEdit: categoryEditReducer,
  categoryUpdate: categoryUpdateReducer,
  categoryDelete: categoryDeleteReducer,

  mallList: mallListReducer,
  mallCreate: mallCreateReducer,
  mallEdit: mallEditReducer,
  mallUpdate: mallUpdateReducer,
  mallDelete: mallDeleteReducer,

  supportSend: supportSendReducer,

  rfqCreate: rfqCreateReducer,
  rfqList: rfqListReducer,
  rfqGet: rfqGetReducer,
  quoteSubmit: quoteSubmitReducer,
  rfqQuoteList: rfqQuoteListReducer,
  quoteAccept: quoteAcceptReducer,
  leadList: leadListReducer,

  // categoryList: (state, action) => recordListReducer("Category", state, action),
  // categoryCreate: (state, action) =>
  //   recordCreateReducer("Category", state, action),
  // categoryEdit: (state, action) => recordEditReducer("Category", state, action),
  // categoryUpdate: (state, action) =>
  //   recordUpdateReducer("Category", state, action),
  // categoryDelete: (state, action) =>
  //   recordDeleteReducer("Category", state, action),
});

// const cartItemsFromLocalStorage = localStorage.getItem("cartItems")
//   ? JSON.parse(localStorage.getItem("cartItems"))
//   : [];

// login
const userInfoFromLocalStorage = localStorage.getItem("userInfo")
  ? JSON.parse(localStorage.getItem("userInfo"))
  : null;

const initialState = {
  // cart: {
  //   cartItems: cartItemsFromLocalStorage,
  //   shippingAddress: shippingAddressFromLocalStorage,
  // },
  userLogin: { userInfo: userInfoFromLocalStorage },
};

const middleware = [thunk];

const store = createStore(
  reducer,
  initialState,
  composeWithDevTools(applyMiddleware(...middleware)),
);

export default store;
